/**
 * Layout system type definitions for mobile and desktop variants
 */

export type LayoutVariantType = 'mobile' | 'desktop';

export interface LayoutVariant {
  type: LayoutVariantType;
  breakpoint: number;
  isStreamerMode: boolean;
  toggleStreamerMode: () => void;
  isActuallyDesktop: boolean;
}

export interface LayoutConfig {
  variant: LayoutVariantType;
  breakpoint: number;
  headerHeight: string;
  sidebarWidth?: string;
  mainContentWidth?: string;
}

export interface ResponsiveBreakpoints {
  mobile: number;    // 0px
  tablet: number;    // 768px
  desktop: number;   // 1024px
  wide: number;      // 1280px
}

export interface ComponentVariants {
  categoryNavigation: {
    mobile: 'mobile-grid';
    desktop: 'sidebar-compact';
  };
  financialMetrics: {
    mobile: 'grid-3x2';
    desktop: 'sidebar-stack';
  };
  gameControls: {
    mobile: 'centered-stack';
    desktop: 'sidebar-compact';
  };
}

export interface ResponsiveLayoutProps {
  children: React.ReactNode;
  variant?: LayoutVariantType | 'auto';
  className?: string;
}

export interface ResponsiveLayoutHeaderProps {
  variant: LayoutVariantType;
  className?: string;
}

export interface ResponsiveLayoutContentProps {
  variant: LayoutVariantType;
  children: React.ReactNode;
  className?: string;
}

// Constants for layout system
export const LAYOUT_BREAKPOINTS: ResponsiveBreakpoints = {
  mobile: 0,
  tablet: 768,
  desktop: 1024,
  wide: 1280,
} as const;

export const DEFAULT_LAYOUT_CONFIG: LayoutConfig = {
  variant: 'mobile',
  breakpoint: LAYOUT_BREAKPOINTS.desktop,
  headerHeight: '4rem',
  sidebarWidth: '33.333333%', // 1/3
  mainContentWidth: '66.666667%', // 2/3
} as const;